<script>
  import Header from "../../../lib/components/Header.svelte";
  import Button from "../../../lib/components/Button.svelte";
  import { fly } from "svelte/transition";
  import {
    DataTable,
    Toolbar,
    ToolbarSearch,
    ToolbarContent,
    Modal as DangerModal,
    Select,
    SelectItem,
    MultiSelect,
    TextInput,
    Loading,
  } from "carbon-components-svelte";
  import EditIcon from "../settings/svg/EditIcon.svelte";
  import RemoveIcon from "../settings/svg/RemoveIcon.svelte";
  import Modal from "lib/components/Modal.svelte";
  import { onMount } from "svelte";
  import { fetchWithSession } from "../../../lib/util/fetchWithSession.js";

  let openModalAdd = false;
  let openDangerModal = false;

  let previousToSelect = [];
  let nextToSelect = [];
  let selectedObject = null;
  let selectedType = "";
  let isEditMode = false;
  let newName = "";
  let selectedAddType = "";
  let selectedPrevIds = [];
  let selectedPrevId = "";
  let selectedNextIds = [];

  let saveSuccessful = false;
  let error = false;
  let successMsg = "";
  let errorMsg = "";

  let typeOptions = [
    { id: "Business-Units", text: "Business-Unit" },
    { id: "Departments", text: "Department" },
    { id: "Areas", text: "Area" },
    { id: "Tasks", text: "Task" },
  ];

  let businessUnitsHeaders = [
    { key: "name", value: "Name" },
    { key: "departments", value: "Departments" },
    { key: "edit", value: "Edit", width: "100px" },
    { key: "delete", value: "Delete", width: "100px" },
  ];

  let departmentsHeaders = [
    { key: "name", value: "Name" },
    { key: "areas", value: "Areas" },
    { key: "edit", value: "Edit", width: "100px" },
    { key: "delete", value: "Delete", width: "100px" },
  ];

  let areasHeaders = [
    { key: "name", value: "Name" },
    { key: "tasks", value: "Tasks" },
    { key: "edit", value: "Edit", width: "100px" },
    { key: "delete", value: "Delete", width: "100px" },
  ];

  let tasksHeaders = [
    { key: "name", value: "Name" },
    { key: "task_surveys", value: "Surveys" },
    { key: "edit", value: "Edit", width: "100px" },
    { key: "delete", value: "Delete", width: "100px" },
  ];

  let businessRows;
  let deptRows;
  let areasRows;
  let tasksRows;

  let connections = { departments: [], areas: [], tasks: [] };

  let loading = true;

  $: if (businessRows && deptRows && areasRows && tasksRows) loading = false;

  $: types = [
    {
      type: "Business-Units",
      headers: businessUnitsHeaders,
      rows: businessRows,
    },
    { type: "Departments", headers: departmentsHeaders, rows: deptRows },
    { type: "Areas", headers: areasHeaders, rows: areasRows },
    { type: "Tasks", headers: tasksHeaders, rows: tasksRows },
  ];

  $: if (isEditMode && selectedType && openModalAdd) {
    setModalData(selectedType);
    getSelected(selectedType);
  } else if (!isEditMode && selectedAddType) {
    setModalData(selectedAddType);
    setDefaulselectedPrevId();
    selectedPrevIds = [];
    selectedNextIds = [];
  }

  function setDefaulselectedPrevId() {
    selectedPrevId = previousToSelect[0]?.id || "";
  }

  function setModalData(type) {
    previousToSelect = getOptionsForType(type);
    //nextToSelect = getNextOptionsForType(type);
  }

  function getLabelType(type) {
    let index = typeOptions.findIndex((item) => item.id === type);
    let label = typeOptions[index - 1].text;
    return label;
  }

  function getNextLabelType(type) {
    let index = typeOptions.findIndex((item) => item.id === type);
    let label = typeOptions[index + 1].text;
    return label;
  }

  function getSelected(selectedType) {
    if (selectedType === "Business-Units" || selectedType === "Business-Unit") {
      selectedNextIds = selectedObject.departments
        ? selectedObject.departments.map((proc) => proc.id)
        : [];
    } else if (selectedType === "Departments") {
      selectedPrevId = selectedObject.business_unit.id;
      selectedPrevIds = selectedObject.business
        ? selectedObject.business.map((p) => p.id)
        : [];
      selectedNextIds = selectedObject.areas
        ? selectedObject.areas.map((proc) => proc.id)
        : [];
    } else if (selectedType === "Areas") {
      selectedPrevId = selectedObject.department.id;
      selectedPrevIds = selectedObject.departments
        ? selectedObject.departments.map((d) => d.id)
        : [];
      selectedNextIds = selectedObject.tasks
        ? selectedObject.tasks.map((obj) => obj.id)
        : [];
    } else if (selectedType === "Tasks") {
      selectedPrevId = selectedObject.area.id;
      selectedPrevIds = selectedObject.areas
        ? selectedObject.areas.map((proc) => proc.id)
        : [];
      selectedNextIds = [];
    }
  }

  function getOptionsForType(type) {
    if (type === "Departments" || type === "Department") {
      return businessRows.map(({ id, name }) => ({ id, text: name }));
    } else if (type === "Areas" || type === "Area") {
      return deptRows.map(({ id, name }) => ({ id, text: name }));
    } else if (type === "Tasks" || type === "Task") {
      return areasRows.map(({ id, name }) => ({ id, text: name }));
    }
    return [];
  }

  // function getNextOptionsForType(type) {
  //   if (type === "Business-Units" || type === "Business-Unit") {
  //     return deptRows.map(({ id, name }) => ({ id, text: name }));
  //   } else if (type === "Departments" || type === "Department") {
  //     return areasRows.map(({ id, name }) => ({ id, text: name }));
  //   } else if (type === "Areas" || type === "Area") {
  //     return tasksRows.map(({ id, name }) => ({ id, text: name }));
  //   } else if (type === "Tasks" || type === "Task") {
  //     return [];
  //   }
  //   return [];
  // }

  function refreshTables() {
    getBusinessRows();
    getDepartments();
    getTasks();
    getAreas();
  }

  function getBusinessRows() {
    fetchWithSession("/api/knextractor/business-units/")
      .then((response) => response.json())
      .then((data) => {
        businessRows = data;
      });
  }
  function getDepartments() {
    fetchWithSession("/api/knextractor/departments")
      .then((response) => response.json())
      .then((data) => {
        deptRows = data;
      });
  }

  function getAreas() {
    fetchWithSession("/api/knextractor/areas")
      .then((response) => response.json())
      .then((data) => {
        areasRows = data;
      });
  }
  function getTasks() {
    fetchWithSession("/api/knextractor/tasks")
      .then((response) => response.json())
      .then((data) => {
        tasksRows = data;
      });
  }

  function deleteSelected() {
    if (!selectedObject || !selectedType) return;
    let typeName = selectedType.toLowerCase();

    fetchWithSession(`/api/knextractor/${typeName}/${selectedObject.id}`, {
      method: "DELETE",
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          openDangerModal = false;
          return;
        }
        openDangerModal = false;
        // Refresh the data after deletion
        refreshTables();
      });
  }

  function setSelectedValues(selectedIds, items) {
    const values = Object.entries(items)
      .filter(([key, value]) => selectedIds.includes(value.id))
      .map(([key, value]) => value.text);
    return '"' + values.join('" , "') + '"';
  }
  function openEditModal(type, object) {
    isEditMode = true;
    selectedType = type;
    selectedAddType = "";
    selectedObject = object;
    newName = object.name || "";
    if (type === "Business-Units") {
      selectedNextIds = object.departments
        ? object.departments.map((obj) => obj.id)
        : [];
    } else if (type === "Departments") {
      selectedPrevIds = object.Business
        ? object.Business.map((dept) => dept.id)
        : [];
      selectedNextIds = object.Areas ? object.Areas.map((obj) => obj.id) : [];
    } else if (type === "Areas") {
      selectedPrevIds = object.departments
        ? object.departments.map((proc) => proc.id)
        : [];
      selectedNextIds = object.tasks ? object.tasks.map((proc) => proc.id) : [];
    } else if (type === "Tasks") {
      selectedPrevIds = object.areas ? object.areas.map((proc) => proc.id) : [];
    }
    openModalAdd = true;
  }

  function hasConnetions(selectedObject) {
    if (!selectedObject) return false;
    connections = { departments: [], areas: [], tasks: [] };
    if (
      selectedObject.departments &&
      Array.isArray(selectedObject.departments)
    ) {
      connections.departments = selectedObject.departments.map(
        (department) => department.name
      );
      deptRows
        .filter((department) =>
          selectedObject.departments.some((dept) => dept.id === department.id)
        )
        .forEach((department) => {
          department.areas.forEach((area) => {
            connections.areas.push(area.name);
            areasRows
              .find((areaRow) => areaRow.id === area.id)
              .tasks.forEach((task) => connections.tasks.push(task.name));
          });
        });
    } else if (selectedObject.areas && Array.isArray(selectedObject.areas)) {
      connections.areas = selectedObject.areas.map((area) => area.name);

      areasRows
        .filter((area) =>
          selectedObject.areas.some((sArea) => area.id === sArea.id)
        )
        .forEach((area) =>
          area.tasks.forEach((task) => {
            connections.tasks.push(task.name);
          })
        );
    } else if (selectedObject.tasks && Array.isArray(selectedObject.tasks)) {
      connections.tasks = selectedObject.tasks.map((task) => task.name);
    }

    return (
      connections.departments.length > 0 ||
      connections.areas.length > 0 ||
      connections.tasks.length > 0
    );
  }

  function openAddModal() {
    isEditMode = false;
    selectedType = "";
    selectedAddType = "";
    selectedObject = null;
    newName = "";
    selectedPrevIds = [];
    selectedNextIds;
    openModalAdd = true;
  }

  function setSaveData(selectedType) {
    let body = { name: newName };
    if (selectedType === "Departments") {
      body.business_unit = selectedPrevId;
    } else if (selectedType === "Areas") {
      body.department = selectedPrevId;
    } else if (selectedType === "Tasks") {
      if (selectedPrevId) {
        body.area = selectedPrevId;
      }
    }
    return body;
  }

  function createElement() {
    if (!newName || !selectedAddType) return;
    let body = setSaveData(selectedAddType);
    let typeName = selectedAddType.toLowerCase();

    fetchWithSession(`/api/knextractor/${typeName}`, {
      method: "POST",
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          openModalAdd = false;
          return;
        }
        openModalAdd = false;
        // Refresh the data after creation
        refreshTables();
      });
  }

  function updateElement() {
    if (!newName || !selectedType || !selectedObject) return;
    let body = setSaveData(selectedType);
    let typeName = selectedType.toLowerCase();

    fetchWithSession(`/api/knextractor/${typeName}/${selectedObject.id}`, {
      method: "PATCH",
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          openModalAdd = false;
          return;
        }
      openModalAdd = false;
        // Refresh the data after update
        refreshTables();
      });
  }

  onMount(() => {
    refreshTables();
  });
</script>

<Header section="Presets" breadcrumb="">
  <Button
    variant="secondary"
    iconLeft={true}
    setting={true}
    text="Add new Element"
    icon="plus"
    on:click={openAddModal}
  />
</Header>
{#if loading}
  <Loading></Loading>
{:else}
  {#each types as type}
    <section>
      <div class="header">
        <h1>{type.type}</h1>
      </div>
      <div>
        <DataTable
          class="custom-table"
          headers={type.headers}
          rows={type.rows}
          sortable
        >
          <Toolbar>
            <ToolbarContent>
              <ToolbarSearch shouldFilterRows persistent />
            </ToolbarContent>
          </Toolbar>
          <svelte:fragment slot="cell" let:row let:cell>
            {#if cell.key === "edit"}
              <button
                class="edit-remove-btn"
                on:click={() => openEditModal(type.type, row)}
                ><EditIcon /></button
              >
            {:else if cell.key === "delete"}
              <button
                class="edit-remove-btn"
                on:click={() => {
                  selectedType = type.type;
                  selectedObject = row;
                  openDangerModal = true;
                }}><RemoveIcon /></button
              >
            {:else if (cell.key === "departments" || cell.key === "areas" || cell.key === "tasks") && Array.isArray(cell.value)}
              {cell.value.map((element) => element.name).join(", ")}
            {:else if cell.key === "task_surveys" && Array.isArray(cell.value)}
              {cell.value.map((surveys) => surveys.survey.name).join(", ")}
            {:else}
              {cell?.value || "-"}
            {/if}
          </svelte:fragment>
        </DataTable>
      </div>
    </section>
  {/each}

  

  <DangerModal
    preventCloseOnClickOutside
    danger
    bind:open={openDangerModal}
    modalHeading="Delete"
    primaryButtonText="Delete"
    secondaryButtonText="Cancel"
    on:click:button--primary={deleteSelected}
    on:click:button--secondary={() => (openDangerModal = false)}
  >
    <p class="deleteModalBody">
      Are you sure you want to delete this {selectedType.slice(0, -1)}:
      <span class="project-name">{selectedObject?.name}</span>?
      {#if hasConnetions(selectedObject)}
        {#if connections.departments.length > 0}
          <p>
            The associated departments will also be deleted: <span
              >{connections.departments.join(", ")}</span
            >
          </p>
        {/if}
        {#if connections.areas.length > 0}
          <p>
            The associated areas will also be deleted: <span
              >{connections.areas.join(", ")}</span
            >
          </p>
        {/if}
        {#if connections.tasks.length > 0}
          <p>
            The associated tasks will also be deleted: <span
              >{connections.tasks.join(", ")}</span
            >
          </p>
        {/if}
      {/if}
      <span class="orange">This action cannot be undone.</span>
    </p>
  </DangerModal>

  <Modal
    modalHeading={isEditMode ? `Edit ${selectedType}` : "Add New Item"}
    bind:open={openModalAdd}
    actions
    autowidth
    preventCloseOnClickOutside
    primaryButtonText="Save"
    secondaryButtonText="Cancel"
    on:click:button--secondary={() => (openModalAdd = false)}
    primaryButtonAction={selectedType ? updateElement : createElement}
  >
    {#if !isEditMode}
      <Select labelText="Select Type" bind:selected={selectedAddType}>
        <SelectItem value="" text="" />
        {#each typeOptions as option}
          <SelectItem value={option.id} text={option.text} />
        {/each}
      </Select>
      <br />
    {/if}

    {#if (isEditMode && selectedType) || (!isEditMode && selectedAddType)}
      <TextInput
        labelText="{isEditMode
          ? selectedType.slice(0, -1)
          : selectedAddType.slice(0, -1)} name"
        placeholder="Enter {isEditMode
          ? selectedType.slice(0, -1)
          : selectedAddType.slice(0, -1)} name"
        bind:value={newName}
      />
      <br />
      {#if (isEditMode && selectedType !== "Business-Units") || (!isEditMode && selectedAddType !== "Business-Units")}
        {#key previousToSelect}
          <Select
            bind:selected={selectedPrevId}
            labelText="Select {getLabelType(
              isEditMode ? selectedType : selectedAddType
            )}"
          >
            {#each previousToSelect as select}
              <SelectItem value={select.id} text={select.text}></SelectItem>
            {/each}
          </Select>
        {/key}
      {/if}
      <!-- {#if (isEditMode && selectedType !== "Tasks") || (!isEditMode && selectedAddType !== "Tasks")}
      {#key nextToSelect}
        <MultiSelect
          titleText="Select {getNextLabelType(
            isEditMode ? selectedType : selectedAddType
          )}"
          bind:selectedIds={selectedNextIds}
          label={selectedNextIds.length > 0
            ? setSelectedValues(selectedNextIds, nextToSelect)
            : `Select ${getNextLabelType(isEditMode ? selectedType : selectedAddType)}`}
          items={nextToSelect}
        />
      {/key}
    {/if} -->
    {/if}
  </Modal>
{/if}

<style>
  section {
    background: var(--pax-smoke);
    width: 100%;
    padding: 12px;
  }
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 8px;
  }
  .header h1 {
    overflow: hidden;
    color: var(--pax-black);
    text-overflow: ellipsis;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  .edit-remove-btn {
    background: var(--pax-black);
    width: 30px;
    height: 30px;
    border-radius: 4px;
    display: grid;
    place-items: center;
  }

  .deleteModalBody {
    padding: 23px 0px 23px 0px;
    font-family: Inter;
    font-size: 14px;
  }

  .deleteModalBody span {
    font-weight: 700;
  }

  .orange {
    color: var(--pax-orange);
  }

  .deleteModalBody .project-name {
    font-weight: bold;
  }
</style>
